import { Component, Input, ViewEncapsulation } from '@angular/core';


@Component({
    selector: 'i360-warning-message',
    encapsulation: ViewEncapsulation.None,
    template: `
        <div [ngClass]="additionalStyles.concat(['warning-message'])">
            <div class="flexer flex-nowrap align-center">
                <i class="material-icons">error_outline</i>
                <span>
                    <ng-content></ng-content>
                </span>
            </div>
        </div>
    `,
    styleUrls: ['./warning-message.component.scss'],
})
export class WarningMessageComponent {
    @Input() additionalStyles: [string] = <any>[];
}
